import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/tenantSignupRequestSlice";

import tenantSignupRequestApis from "src/api/tenantSignupRequest";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

const GetSignupRequestsListSaga = function* GetSignupRequestsListSaga({
  payload,
}: ReturnType<typeof actions.getSignupRequestsListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantSignupRequestApis.list,
      payload
    );
    yield put(actions.getSignupRequestsListSuccess(response));
  } catch (error) {
    yield put(
      actions.getSignupRequestsListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const ApproveSignupRequestSaga = function* ApproveSignupRequestSaga({
  payload,
}: ReturnType<typeof actions.approveSignupRequestRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantSignupRequestApis.approve,
      payload.id
    );
    yield put(actions.approveSignupRequestSuccess(response));
  } catch (error) {
    yield put(
      actions.approveSignupRequestError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const RejectSignupRequestSaga = function* RejectSignupRequestSaga({
  payload,
}: ReturnType<typeof actions.rejectSignupRequestRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantSignupRequestApis.reject,
      payload.id
    );
    yield put(actions.rejectSignupRequestSuccess(response));
  } catch (error) {
    yield put(
      actions.rejectSignupRequestError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const DeleteSignupRequestSaga = function* DeleteSignupRequestSaga({
  payload,
}: ReturnType<typeof actions.deleteSignupRequestRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantSignupRequestApis.delete,
      payload.id
    );
    yield put(actions.deleteSignupRequestSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteSignupRequestError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

export default function* tenantSignupRequestSaga() {
  yield all([
    takeEvery(actions.getSignupRequestsListRequest, GetSignupRequestsListSaga),
  ]);
  yield all([
    takeEvery(actions.approveSignupRequestRequest, ApproveSignupRequestSaga),
  ]);
  yield all([
    takeEvery(actions.rejectSignupRequestRequest, RejectSignupRequestSaga),
  ]);
  yield all([
    takeEvery(actions.deleteSignupRequestRequest, DeleteSignupRequestSaga),
  ]);
}
